module.exports = __webpack_public_path__ + "static/mosmosh-dbf9267a2aacff08a6b644d773d0c39f.png";